import policy from '../../../shared/permissions.json';
import pages from '../../../shared/pagePermissions.json';

export function hasPermission(user, permission) {
  return Boolean(user && Array.isArray(user.permissions) && user.permissions.includes(permission));
}

export function pagePermission(path) {
  const pathname = path.split('?')[0].replace(/\/+$/, '') || '/';
  const prefix = Object.keys(pages).sort((a, b) => b.length - a.length)
    .find((key) => pathname === key || pathname.startsWith(`${key}/`));
  return prefix ? pages[prefix] : null;
}

export function canAccessPath(user, path) {
  const permission = pagePermission(path);
  return Boolean(permission && hasPermission(user, permission));
}

export function homeForUser(user) {
  if (user?.role === 'manager' && canAccessPath(user, '/out-of-stock-sales')) return '/out-of-stock-sales';
  return Object.keys(pages).find((path) => canAccessPath(user, path)) || '/access-denied';
}

export function filterNavigation(items, user) {
  return items.flatMap((item) => {
    if (item.submenu) {
      const submenu = filterNavigation(item.submenu, user);
      return submenu.length ? [{ ...item, submenu }] : [];
    }
    return item.href && canAccessPath(user, item.href) ? [item] : [];
  });
}
